var exports = {
  "nM": "row__Uv7EVd",
  "Kk": "icon__VkTsyT",
  "Qq": "text__7Z6rCk",
  "lN": "emphasis__dyfDgq",
  "Zd": "reasoning__RLubS-",
};

module.exports = exports;
